import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';

import { fetchCustomerOrderDetail } from '#/api/crmMgmt/customerOrder/fetchDetail';
import CustomerOrderMainInfoCard from '#/modules/crmMgmt/customerOrder/components/CustomerOrderMainInfoCard';
import { getCustomerOrderApiErrorMessage } from '#/modules/crmMgmt/customerOrder/helper/apiError';
import { customerOrderDetailQueryKey } from '#/utils/queryKeys';

function normalizeCustomerOrderId(value) {
  if (value == null || value === '') {
    return '';
  }
  return String(value).trim();
}

/**
 * 銷貨單 create／edit 上方客訂卡：有 id 才 GET；無 CommandBar。
 * 客訂載入失敗不擋銷貨單表單。
 */
const LinkedCustomerOrderInfoCard = ({
  customerOrderId,
  compact = false,
  nested = false,
}) => {
  const id = normalizeCustomerOrderId(customerOrderId);
  const enabled = Boolean(id);

  const detailQuery = useQuery({
    queryKey: customerOrderDetailQueryKey(id),
    queryFn: () => fetchCustomerOrderDetail(id),
    enabled,
  });

  if (!enabled) {
    return null;
  }

  const detail = detailQuery.data?.data;

  return (
    <div>
      {detailQuery.isLoading ? (
        <p className="text-sm text-slate-500">載入客戶訂單中…</p>
      ) : null}
      {detailQuery.isError ? (
        <p className="text-sm text-destructive">
          {getCustomerOrderApiErrorMessage(detailQuery.error, '載入客戶訂單失敗')}
        </p>
      ) : null}
      {detail ? (
        <CustomerOrderMainInfoCard detail={detail} compact={compact} nested={nested} />
      ) : null}
    </div>
  );
};

LinkedCustomerOrderInfoCard.propTypes = {
  customerOrderId: PropTypes.string,
  compact: PropTypes.bool,
  nested: PropTypes.bool,
};

export default LinkedCustomerOrderInfoCard;
